import React, { useState } from 'react';
import { withLocalize } from 'react-localize-redux';
import { Checkbox, Label, Loader as Spinner, Icon, Input } from 'semantic-ui-react';
import { push } from 'connected-react-router';

import DataTable, { Action } from '@/components/DataTable';
import { useGetWebhookEndpointsQuery } from '@/services/bmApi';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { getCompanyId } from '@/store/reducers/newAuth';
import useTranslate from '@/hooks/useTranslate';
import { WebhookEndpoint } from '@/types';
import TestWebhookModal from '@/components/TestWebhookModal';

const SecretsRenderer : React.FC<{secret: string, id: string}> = (props) => {
    const mapToWildcard = Array.from(props.secret).map(char => '*').join('');
    const [secret, setSecret] = useState(mapToWildcard);
    const [openTestWebhookModal, setOpenTestWebhookModal] = useState(false);

    const toggleSecret = () => {
        if(Array.from(secret).every(char => char === '*')) {
            setSecret(props.secret)
        } else {
            setSecret(mapToWildcard)
        }
    }

    const testWebhook = () => {
        setOpenTestWebhookModal(true);
    }

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Input
                    icon={<Icon name="eye" onClick={toggleSecret} inverted circular link />}
                    value={secret}
                    readOnly
                />
                <Icon
                    name="paper plane"
                    title="Test webhook"
                    inverted
                    circular
                    link
                    onClick={testWebhook}
                    data-testid={`test-webhook-${props.id}`}
                />
            </div>
            {openTestWebhookModal && (
                <TestWebhookModal onCancel={() => setOpenTestWebhookModal(false)}
                    webhookId={props.id}
                />
            )}
        </>
    );
}

const SystemSetttingsForm: React.FC = (props) => {
    const { translate } = useTranslate();
    const companyId = useAppSelector(getCompanyId);
    const dispatch = useAppDispatch();
    const endpointsData = useGetWebhookEndpointsQuery({
        CompanyId: companyId,
        // @ts-ignore
        IncludeSecret: true
    });

    const Enabled = (row: WebhookEndpoint) => {
        return <Checkbox readOnly disabled checked={!row.Disabled}/>
    };

    const EventTypes = (row: WebhookEndpoint) => {
        return row.EventTypes ? row.EventTypes.map(evt => (<Label content={evt} />)) : null;
    };

    const columns = [
        {
            name: translate('webhooks.endpoints.enabled.text'),
            renderer: Enabled,
        },
        {
            name: translate('webhooks.endpoints.url.text'),
            attribute: 'Url',
            type: 'text',
        },
        {
            name: translate('webhooks.endpoints.description.text'),
            attribute: 'Description',
            type: 'text',
        },
        {
            name: translate('webhooks.endpoints.eventTypes.text'),
            renderer: EventTypes,
        },
        {
            name: translate('webhooks.endpoints.secret.text'),
            attribute: 'Secret',
            renderer: (row: any) => {
                return row.Secret ? <SecretsRenderer secret={row.Secret} id={row.Id}/> : null
            }
        }
    ];

    const rowActions: Action[] = [
        {
            name: translate('common.edit'),
            icon: 'edit',
            color: 'blue',
            onAction: (webhook: any) => {
                dispatch(push(`/webhooks/endpoint/${webhook.Id}`));
            },
        },
    ];


    return (
        <>
            {endpointsData.isFetching ? <Spinner data-testid="loader" active /> : null}
            <DataTable
                data={endpointsData.data?.Endpoints}
                columns={columns}
                actions={rowActions}
            />
        </>
    );
};

export default withLocalize(SystemSetttingsForm);
